(() => {
  'use strict';

  /*
   * ============================================================
   * ВКУСНО — АВТОМАТИЧНИ ДОСТАВКИ V4
   * ============================================================
   *
   * ОПТИМИЗИРАНА ВЕРСИЯ
   *
   * - без initial cart request на продуктови страници
   * - без global MutationObserver върху document.body
   * - без page refresh
   * - без конфликт с Dawn line indexes
   *
   * Под 30€ за деня:
   * → доставка 2,99€
   *
   * 30€ или повече за деня:
   * → безплатна доставка
   *
   * ============================================================
   */

  if (window.__vkusnoDeliveryFeesV4Loaded) {
    return;
  }

  window.__vkusnoDeliveryFeesV4Loaded = true;


  /*
   * ============================================================
   * НАСТРОЙКИ
   * ============================================================
   */

  const CONFIG = {
    freeDeliveryGoal: 2500,

    deliveryOptionName:
      'Ден за доставка',

    days: {
      'четвъртък': {
        feeVariantId:
          54446082195798
      },

      'неделя': {
        feeVariantId:
          54446084489558
      }
    }
  };


  /*
   * ============================================================
   * SHOPIFY ROUTES
   * ============================================================
   */

  const shopRoot =
    window.Shopify?.routes?.root || '/';

  const cartUrl =
    shopRoot + 'cart.js';

  const cartUpdateUrl =
    shopRoot + 'cart/update.js';

  const nativeFetch =
    window.fetch.bind(window);


  /*
   * ============================================================
   * ВЪТРЕШНО СЪСТОЯНИЕ
   * ============================================================
   */

  let syncTimer = null;

  let syncPromise = null;

  let syncAgainAfterCurrent = false;

  let checkoutInProgress = false;

  let dawnListenerAttached = false;


  /*
   * ============================================================
   * ПОМОЩНИ ФУНКЦИИ
   * ============================================================
   */

  const normalizeText = (value) => {
    return String(value || '')
      .trim()
      .toLocaleLowerCase('bg-BG')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ');
  };


  const isCartPage = () => {
    const path =
      window.location.pathname
        .replace(/\/+$/, '');

    return path.endsWith('/cart');
  };


  const getFeeDayByVariantId = (
    variantId
  ) => {
    const numericId =
      Number(variantId);


    for (
      const [day, settings]
      of Object.entries(CONFIG.days)
    ) {
      if (
        Number(
          settings.feeVariantId
        ) === numericId
      ) {
        return day;
      }
    }


    return '';
  };


  /*
   * ============================================================
   * НАМИРАМЕ ДЕНЯ НА ПРОДУКТА
   * ============================================================
   */

  const getDeliveryDayFromItem = (
  item
) => {

  /*
   * Разпознава:
   *
   * Четвъртък
   * Малка - Четвъртък
   * Голяма - Четвъртък
   *
   * Неделя
   * Малка - Неделя
   * Голяма - Неделя
   */

  const detectDay = (value) => {
    const text =
      normalizeText(value);


    for (
      const day
      of Object.keys(CONFIG.days)
    ) {
      if (
        text.includes(day)
      ) {
        return day;
      }
    }


    return '';
  };


  const options =
    Array.isArray(
      item.options_with_values
    )
      ? item.options_with_values
      : [];


  /*
   * Първо търсим конкретно
   * "Ден за доставка".
   */

  const namedOption =
    options.find((option) => {
      return (
        normalizeText(option.name) ===
        normalizeText(
          CONFIG.deliveryOptionName
        )
      );
    });


  if (namedOption) {
    const day =
      detectDay(
        namedOption.value
      );


    if (day) {
      return day;
    }
  }


  /*
   * После проверяваме
   * всички option values.
   *
   * Тук ще хванем например:
   *
   * "Малка - Четвъртък"
   */

  for (const option of options) {
    const day =
      detectDay(
        option.value
      );


    if (day) {
      return day;
    }
  }


  /*
   * Резервна проверка
   * през variant_options.
   */

  const variantOptions =
    Array.isArray(
      item.variant_options
    )
      ? item.variant_options
      : [];


  for (
    const optionValue
    of variantOptions
  ) {
    const day =
      detectDay(
        optionValue
      );


    if (day) {
      return day;
    }
  }


  /*
   * Последен fallback:
   * variant title.
   */

  const titleDay =
    detectDay(
      item.variant_title
    );


  if (titleDay) {
    return titleDay;
  }


  return '';
};


  /*
   * ============================================================
   * ЧЕТЕМ КОЛИЧКАТА
   * ============================================================
   */

  const getCart = async () => {
    const response =
      await nativeFetch(
        cartUrl,
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );


    if (!response.ok) {
      throw new Error(
        'Не успяхме да прочетем количката.'
      );
    }


    return response.json();
  };


  /*
   * ============================================================
   * АНАЛИЗ НА КОЛИЧКАТА
   * ============================================================
   */

  const analyzeCart = (cart) => {
    const dayTotals = {
      'четвъртък': 0,
      'неделя': 0
    };


    const feeItems = {
      'четвъртък': [],
      'неделя': []
    };


    cart.items.forEach((item) => {
      const variantId =
        Number(
          item.variant_id ||
          item.id
        );


      /*
       * Служебен продукт
       * за доставка.
       */

      const feeDay =
        getFeeDayByVariantId(
          variantId
        );


      if (feeDay) {
        feeItems[
          feeDay
        ].push(item);

        return;
      }


      /*
       * Нормален продукт.
       */

      const deliveryDay =
        getDeliveryDayFromItem(item);


      if (!deliveryDay) {
        return;
      }


      const lineTotal =
        Number(
          item.final_line_price ??
          item.line_price ??
          0
        );


      dayTotals[
        deliveryDay
      ] += lineTotal;
    });


    return {
      dayTotals,
      feeItems
    };
  };


  /*
   * ============================================================
   * СЪЗДАВАМЕ UPDATE ПЛАНА
   * ============================================================
   */

  const buildUpdates = (cart) => {
    const {
      dayTotals,
      feeItems
    } = analyzeCart(cart);


    const updates = {};


    for (
      const day
      of Object.keys(CONFIG.days)
    ) {
      const total =
        dayTotals[day];


      const currentFeeItems =
        feeItems[day];


      const shouldHaveFee =
        total > 0 &&
        total <
          CONFIG.freeDeliveryGoal;


      /*
       * ========================================================
       * ТРЯБВА ДА ИМА ДОСТАВКА
       * ========================================================
       */

      if (shouldHaveFee) {
        /*
         * Няма доставка.
         */

        if (
          currentFeeItems.length === 0
        ) {
          const variantId =
            CONFIG
              .days[day]
              .feeVariantId;


          updates[
            String(variantId)
          ] = 1;


          continue;
        }


        /*
         * Доставката трябва
         * да е точно 1 брой.
         */

        const firstFeeItem =
          currentFeeItems[0];


        if (
          Number(
            firstFeeItem.quantity
          ) !== 1
        ) {
          updates[
            firstFeeItem.key
          ] = 1;
        }


        /*
         * Махаме дублирани
         * доставки.
         */

        for (
          let index = 1;
          index <
            currentFeeItems.length;
          index++
        ) {
          updates[
            currentFeeItems[
              index
            ].key
          ] = 0;
        }


        continue;
      }


      /*
       * ========================================================
       * НЕ ТРЯБВА ДА ИМА ДОСТАВКА
       * ========================================================
       */

      for (
        const feeItem
        of currentFeeItems
      ) {
        updates[
          feeItem.key
        ] = 0;
      }
    }


    return {
      updates,
      dayTotals
    };
  };


  const hasUpdates = (updates) => {
    return (
      Object.keys(updates).length > 0
    );
  };


  /*
   * ============================================================
   * CART ROOTS
   * ============================================================
   *
   * Много важно:
   *
   * Работим само вътре в количката.
   *
   * Никога не сканираме целия body.
   */

  const getCartRoots = () => {
    const roots = [];


    const selectors = [
      '#main-cart-items',
      '#main-cart-footer',
      'cart-drawer'
    ];


    selectors.forEach((selector) => {
      document
        .querySelectorAll(selector)
        .forEach((element) => {
          if (
            !roots.includes(element)
          ) {
            roots.push(element);
          }
        });
    });


    return roots;
  };


  /*
   * ============================================================
   * ЗАКЛЮЧВАМЕ DELIVERY РЕДОВЕТЕ
   * ============================================================
   */

  const isDeliveryFeeRow = (row) => {
    const text =
      normalizeText(
        row?.textContent
      );


    return (
      text.includes(
        'доставка - четвъртък'
      ) ||
      text.includes(
        'доставка - неделя'
      )
    );
  };


  const lockDeliveryFeeRows = () => {
    getCartRoots()
      .forEach((root) => {
        root
          .querySelectorAll(
            '.cart-item'
          )
          .forEach((row) => {
            if (
              isDeliveryFeeRow(row)
            ) {
              row.classList.add(
                'vkusno-delivery-fee-row'
              );
            }
          });
      });
  };


  /*
   * ============================================================
   * SCOPED MUTATION OBSERVERS
   * ============================================================
   *
   * Старият код наблюдаваше:
   *
   * document.body
   *
   * Новият наблюдава само:
   *
   * - main cart
   * - cart footer
   * - cart drawer
   */

  const observeCartRoots = () => {
    getCartRoots()
      .forEach((root) => {
        if (
          root.dataset
            .vkusnoDeliveryObserved ===
          'true'
        ) {
          return;
        }


        root.dataset
          .vkusnoDeliveryObserved =
          'true';


        const observer =
          new MutationObserver(() => {
            requestAnimationFrame(
              lockDeliveryFeeRows
            );
          });


        observer.observe(
          root,
          {
            childList: true,
            subtree: true
          }
        );
      });
  };


  /*
   * ============================================================
   * DAWN SECTIONS
   * ============================================================
   */

  const getSectionsToRender = () => {
    const sections = [];


    const mainCartItems =
      document.getElementById(
        'main-cart-items'
      );


    const mainCartFooter =
      document.getElementById(
        'main-cart-footer'
      );


    /*
     * CART PAGE
     */

    if (
      mainCartItems &&
      mainCartFooter
    ) {
      sections.push(
        {
          id:
            'main-cart-items',

          section:
            mainCartItems.dataset.id,

          selector:
            '.js-contents',

          type:
            'dawn'
        },

        {
          id:
            'cart-icon-bubble',

          section:
            'cart-icon-bubble',

          selector:
            '.shopify-section',

          type:
            'dawn'
        },

        {
          id:
            'cart-live-region-text',

          section:
            'cart-live-region-text',

          selector:
            '.shopify-section',

          type:
            'dawn'
        },

        {
          id:
            'main-cart-footer',

          section:
            mainCartFooter.dataset.id,

          selector:
            '.js-contents',

          type:
            'dawn'
        }
      );
    }


    /*
     * CART DRAWER
     */

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (cartDrawer) {
      sections.push(
        {
          id:
            'CartDrawer',

          section:
            'cart-drawer',

          type:
            'drawer'
        }
      );
    }


    /*
     * Извън cart page:
     *
     * drawer + cart bubble.
     */

    if (
      !mainCartItems &&
      cartDrawer
    ) {
      sections.push(
        {
          id:
            'cart-icon-bubble',

          section:
            'cart-icon-bubble',

          selector:
            '.shopify-section',

          type:
            'dawn'
        }
      );
    }


    return sections.slice(0, 5);
  };


  /*
   * ============================================================
   * UPDATE ЗАЯВКА
   * ============================================================
   */

  const updateDeliveryFees = async (
    updates,
    sectionsToRender
  ) => {
    const body = {
      updates: updates
    };


    if (
      sectionsToRender.length > 0
    ) {
      body.sections =
        sectionsToRender.map(
          (section) =>
            section.section
        );


      body.sections_url =
        window.location.pathname;
    }


    const response =
      await nativeFetch(
        cartUpdateUrl,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          credentials:
            'same-origin',

          body:
            JSON.stringify(body)
        }
      );


    if (!response.ok) {
      let message =
        'Не успяхме да обновим доставката.';


      try {
        const errorData =
          await response.json();


        message =
          errorData.description ||
          errorData.message ||
          errorData.errors ||
          message;
      } catch (error) {
        /*
         * Оставяме стандартното съобщение.
         */
      }


      throw new Error(
        String(message)
      );
    }


    return response.json();
  };


  /*
   * ============================================================
   * HTML HELPER
   * ============================================================
   */

  const getSectionInnerHTML = (
    html,
    selector
  ) => {
    const parsed =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const source =
      parsed.querySelector(
        selector
      );


    return source
      ? source.innerHTML
      : '';
  };


  /*
   * ============================================================
   * RENDER CART БЕЗ REFRESH
   * ============================================================
   */

  const renderUpdatedCart = (
    state,
    sectionsToRender
  ) => {
    if (!state.sections) {
      return;
    }


    for (
      const section
      of sectionsToRender
    ) {
      const html =
        state.sections[
          section.section
        ];


      if (!html) {
        continue;
      }


      /*
       * NORMAL DAWN SECTIONS
       */

      if (
        section.type === 'dawn'
      ) {
        const root =
          document.getElementById(
            section.id
          );


        if (!root) {
          continue;
        }


        const target =
          root.querySelector(
            section.selector
          ) || root;


        const newHTML =
          getSectionInnerHTML(
            html,
            section.selector
          );


        if (newHTML) {
          target.innerHTML =
            newHTML;
        }


        continue;
      }


      /*
       * CART DRAWER
       */

      if (
        section.type === 'drawer'
      ) {
        const parsed =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );


        const selectors = [
          'cart-drawer-items',
          '.cart-drawer__footer'
        ];


        for (
          const selector
          of selectors
        ) {
          const current =
            document.querySelector(
              selector
            );


          const replacement =
            parsed.querySelector(
              selector
            );


          if (
            current &&
            replacement
          ) {
            current.replaceWith(
              replacement
            );
          }
        }
      }
    }


    const isEmpty =
      Number(state.item_count) === 0;


    const mainCartItems =
      document.getElementById(
        'main-cart-items'
      );


    const mainCartFooter =
      document.getElementById(
        'main-cart-footer'
      );


    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (mainCartItems) {
      mainCartItems.classList.toggle(
        'is-empty',
        isEmpty
      );
    }


    if (mainCartFooter) {
      mainCartFooter.classList.toggle(
        'is-empty',
        isEmpty
      );
    }


    if (cartDrawer) {
      cartDrawer.classList.toggle(
        'is-empty',
        isEmpty
      );
    }


    /*
     * След новия HTML:
     *
     * - заключваме delivery редовете
     * - проверяваме новите cart roots
     */

    lockDeliveryFeeRows();

    observeCartRoots();


    document.dispatchEvent(
      new CustomEvent(
        'vkusno:delivery-fees-updated',
        {
          detail: {
            cart: state
          }
        }
      )
    );


    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh'
      )
    );
  };


  /*
   * ============================================================
   * BUSY STATE
   * ============================================================
   */

  const setCartBusy = (busy) => {
    const mainCartItems =
      document.getElementById(
        'main-cart-items'
      );


    if (mainCartItems) {
      mainCartItems.classList.toggle(
        'cart__items--disabled',
        busy
      );
    }
  };


  /*
   * ============================================================
   * ГЛАВНА СИНХРОНИЗАЦИЯ
   * ============================================================
   */

  const syncDeliveryFees =
    async () => {
      if (syncPromise) {
        syncAgainAfterCurrent = true;

        return syncPromise;
      }


      syncPromise = (
        async () => {
          try {
            const cart =
              await getCart();


            const {
              updates,
              dayTotals
            } = buildUpdates(cart);


            /*
             * Всичко е правилно.
             */

            if (
              !hasUpdates(updates)
            ) {
              lockDeliveryFeeRows();


              return {
                ok: true,
                changed: false,
                dayTotals:
                  dayTotals
              };
            }


            setCartBusy(true);


            const sectionsToRender =
              getSectionsToRender();


            const state =
              await updateDeliveryFees(
                updates,
                sectionsToRender
              );


            renderUpdatedCart(
              state,
              sectionsToRender
            );


            return {
              ok: true,
              changed: true,
              dayTotals:
                dayTotals
            };
          } catch (error) {
            console.error(
              '[Вкусно доставки]',
              error
            );


            return {
              ok: false,
              changed: false,
              error: error
            };
          } finally {
            setCartBusy(false);
          }
        }
      )();


      try {
        return await syncPromise;
      } finally {
        syncPromise = null;


        if (
          syncAgainAfterCurrent
        ) {
          syncAgainAfterCurrent =
            false;


          setTimeout(() => {
            scheduleSync(80);
          }, 0);
        }
      }
    };


  /*
   * ============================================================
   * DEBOUNCE
   * ============================================================
   */

  const scheduleSync = (
    delay = 80
  ) => {
    clearTimeout(syncTimer);


    syncTimer =
      setTimeout(() => {
        syncDeliveryFees();
      }, delay);
  };


  /*
   * ============================================================
   * DAWN CART LISTENER
   * ============================================================
   *
   * На продуктова страница
   * системата се събужда чак
   * СЛЕД реално Add to Cart.
   */

  const attachDawnCartListener = () => {
    try {
      if (
        typeof subscribe ===
          'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(
          PUB_SUB_EVENTS.cartUpdate,

          (event) => {
            if (
              event?.source ===
              'vkusno-delivery-fees'
            ) {
              return;
            }


            scheduleSync(80);
          }
        );


        dawnListenerAttached = true;

        return true;
      }
    } catch (error) {
      console.warn(
        '[Вкусно доставки] Dawn listener fallback',
        error
      );
    }


    return false;
  };


  /*
   * ============================================================
   * FALLBACK CART EVENTS
   * ============================================================
   */

  const attachFallbackListeners = () => {
    document.addEventListener(
      'cart:updated',

      () => {
        scheduleSync(150);
      }
    );


    document.addEventListener(
      'change',

      (event) => {
        if (
          event.target.closest?.(
            [
              'cart-items',
              'cart-drawer-items',
              '#main-cart-items'
            ].join(',')
          )
        ) {
          scheduleSync(900);
        }
      }
    );
  };


  /*
   * ============================================================
   * LAZY CART DRAWER CHECK
   * ============================================================
   *
   * Ако клиентът просто отвори
   * количката от иконата:
   *
   * проверяваме доставките тогава,
   * а не при зареждане на продукта.
   */

  const attachCartOpenListener = () => {
    document.addEventListener(
      'click',

      (event) => {
        const opener =
          event.target.closest?.(
            [
              '#cart-icon-bubble',
              '[aria-controls="CartDrawer"]'
            ].join(',')
          );


        if (!opener) {
          return;
        }


        scheduleSync(80);
      },

      true
    );
  };


  /*
   * ============================================================
   * CSS
   * ============================================================
   */

  const injectStyles = () => {
    if (
      document.getElementById(
        'vkusno-delivery-fee-styles'
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'vkusno-delivery-fee-styles';


    style.textContent = `
      .vkusno-delivery-fee-row quantity-input,
      .vkusno-delivery-fee-row quantity-popover,
      .vkusno-delivery-fee-row cart-remove-button,
      .vkusno-delivery-fee-row .quantity,
      .vkusno-delivery-fee-row .quantity__button,
      .vkusno-delivery-fee-row .quantity-popover-container,
      .vkusno-delivery-fee-row .cart-item__quantity-wrapper,
      .vkusno-delivery-fee-row .cart-remove-button,
      .vkusno-delivery-fee-row a[href*="quantity=0"] {
        display: none !important;
      }

      .vkusno-delivery-fee-row .cart-item__name,
      .vkusno-delivery-fee-row .cart-item__media a {
        pointer-events: none !important;
        text-decoration: none !important;
        cursor: default !important;
      }
    `;


    document.head.appendChild(
      style
    );
  };


  /*
   * ============================================================
   * FINAL CHECKOUT CHECK
   * ============================================================
   *
   * Scoped само до cart UI.
   *
   * Не засяга продуктови страници.
   */

  const ensureCorrectBeforeCheckout =
    async () => {
      for (
        let attempt = 0;
        attempt < 3;
        attempt++
      ) {
        const result =
          await syncDeliveryFees();


        if (!result.ok) {
          return false;
        }


        const cart =
          await getCart();


        const {
          updates
        } = buildUpdates(cart);


        if (
          !hasUpdates(updates)
        ) {
          return true;
        }
      }


      return false;
    };


  document.addEventListener(
    'click',

    async (event) => {
      if (checkoutInProgress) {
        return;
      }


      const checkoutButton =
        event.target.closest?.(
          [
            '#main-cart-footer button[name="checkout"]',
            '#main-cart-footer input[name="checkout"]',
            '#main-cart-footer a[href*="/checkout"]',

            '#CartDrawer button[name="checkout"]',
            '#CartDrawer input[name="checkout"]',
            '#CartDrawer a[href*="/checkout"]',

            'cart-drawer button[name="checkout"]',
            'cart-drawer input[name="checkout"]',
            'cart-drawer a[href*="/checkout"]'
          ].join(',')
        );


      if (!checkoutButton) {
        return;
      }


      event.preventDefault();

      event.stopImmediatePropagation();


      checkoutInProgress = true;


      if (
        'disabled' in checkoutButton
      ) {
        checkoutButton.disabled =
          true;
      }


      const isCorrect =
        await ensureCorrectBeforeCheckout();


      if (!isCorrect) {
        checkoutInProgress = false;


        if (
          'disabled' in checkoutButton
        ) {
          checkoutButton.disabled =
            false;
        }


        alert(
          'Не успяхме да обновим доставката. Моля, опитайте отново.'
        );


        return;
      }


      window.location.assign(
        shopRoot + 'checkout'
      );
    },

    true
  );


  /*
   * ============================================================
   * START
   * ============================================================
   */

  const start = () => {
    /*
     * Леки операции.
     *
     * Без cart request.
     */

    injectStyles();

    attachDawnCartListener();

    attachFallbackListeners();

    attachCartOpenListener();


    /*
     * ВАЖНО:
     *
     * Само cart страницата
     * се синхронизира при load.
     *
     * Продуктова страница:
     *
     * - няма /cart.js
     * - няма cart/update.js
     * - няма global observer
     * - няма layout shift
     */

    if (isCartPage()) {
      lockDeliveryFeeRows();

      observeCartRoots();

      scheduleSync(30);
    }
  };


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }


  /*
   * ============================================================
   * BACK / FORWARD CACHE
   * ============================================================
   *
   * Не стартира при нормално page load.
   */

  window.addEventListener(
    'pageshow',

    (event) => {
      if (
        event.persisted &&
        isCartPage()
      ) {
        scheduleSync(100);
      }
    }
  );


  /*
   * ============================================================
   * DEBUG
   * ============================================================
   */

  window.VkusnoDeliveryFees = {
    sync:
      syncDeliveryFees,

    getCart:
      getCart,

    config:
      CONFIG
  };
})();